var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorNoAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Danger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Danger",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-1378-+-Stroke-1379-+-Stroke-1380",
    transform: "translate(3.000000, 3.000000)",
    stroke: "#D0021B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,12 L17,24",
    id: "Stroke-1378",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,29 C18,29.552 17.552,30 17,30 C16.448,30 16,29.552 16,29 C16,28.448 16.448,28 17,28 C17.552,28 18,28.448 18,29 L18,29 Z",
    id: "Stroke-1380"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-1379",
    strokeLinecap: "round",
    d: "M34,34L0,34L17,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNoAnimation);
export default __webpack_public_path__ + "static/media/error_no_animation.e1a496d7f4357287e5fd02cf1bf494d7.svg";
export { ForwardRef as ReactComponent };